import React from "react";
import { Helmet } from "react-helmet";
import "./Contact.css";
import "./shared.css";

function Contact() {
  return (
    <main className="contactPage">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact | Radix Software Solutions</title>
        <meta
          name="description"
          content="Contact Radix Software Solutions for consulting, reporting, and integration projects."
        />
        <meta property="og:title" content="Contact | Radix Software Solutions" />
        <meta
          property="og:description"
          content="Contact Radix Software Solutions for consulting, reporting, and integration projects."
        />
        <meta property="og:site_name" content="Radix Software Solutions" />
        <meta
          property="og:url"
          content="https://www.radixsoftwaresolutions.com/contact"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact | Radix Software Solutions" />
        <meta
          name="twitter:description"
          content="Contact Radix Software Solutions for consulting, reporting, and integration projects."
        />
        <link
          rel="canonical"
          href="https://www.radixsoftwaresolutions.com/contact"
        />
      </Helmet>

      <section className="section contactHero">
        <div className="pageContainer">
          <p className="sectionKicker">Contact</p>
          <h1 className="contactTitle">Contact Radix</h1>
          <p className="paragraphTextStyle contactIntro">
            The first step to any custom project is discovery. We invest heavily
            upfront so we can understand your goals and recommend the right next
            steps.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="pageContainer contactGrid">
          <article className="card contactCard">
            <h2 className="cardTitle">Current availability</h2>
            <p className="paragraphTextStyle contactCopy">
              While we are excited about every opportunity to build or improve
              custom solutions, we are not currently accepting new clients. We
              remain dedicated to delivering the best results for our existing
              projects and look forward to future opportunities when capacity
              allows.
            </p>
          </article>

          <article className="card contactCard">
            <h2 className="cardTitle">When we open new slots</h2>
            <p className="paragraphTextStyle contactCopy">
              Reach out with a short summary of your reporting, integration, or
              automation needs. We will respond with next steps, timelines, and
              any discovery requirements.
            </p>
            <div className="contactHighlight">
              <span>What helps most:</span>
              <ul>
                <li>Systems and data sources involved</li>
                <li>Desired outcomes and timelines</li>
                <li>Stakeholders and decision-makers</li>
              </ul>
            </div>
          </article>
        </div>
      </section>
    </main>
  );
}

export default Contact;
